import useSWR, { SWRResponse } from 'swr'

import { ChatFileResponse, ChatFileTypeParam } from '@api/generated/internal/internalApi'
import { useAgentApi } from '@api/hooks'
import { SWR_SESSION_FILES_KEY } from '@constants/agentTypes'

/**
 * A chat session's generated files, shared by the Files panel and the chips on tool result cards.
 *
 * Every caller must use this hook rather than reading the cache. SWR revalidates through the
 * first-subscribed hook only, and children subscribe before their parent, so a `null` fetcher there
 * cancels the real request and leaves the panel empty until a reload.
 */
export default function useSessionFiles(chatflowId?: string, sessionId?: string): SWRResponse<ChatFileResponse[]> {
  const api = useAgentApi()

  return useSWR<ChatFileResponse[]>(sessionId ? [SWR_SESSION_FILES_KEY, sessionId] : null, async () => {
    if (!chatflowId || !sessionId) return []
    const response = await api.chatFiles.listChatFiles(chatflowId, { sessionId, types: [ChatFileTypeParam.Generated] })
    return (response.data as ChatFileResponse[] | undefined) ?? []
  })
}
